import React from 'react';
import './ValueProposition.css';

function ValueProposition() {
  return (
    <section className="value-proposition">
      <h2>Proposta di valore</h2>
      
      <div className="problem-solution">
        <div className="problem">
          <h3>Il problema</h3>
          <p>
            Le lezioni tradizionali si basano sulla ripetizione meccanica: un argomento alla volta, 
            esercizi uniformi, verifica e oblio. Gli studenti capiscono sul momento ma dimenticano 
            rapidamente. Questo approccio sovraccarica la memoria a breve termine senza costruire 
            competenze durature.
          </p>
        </div>
        
        <div className="solution">
          <h3>La soluzione: due tecniche scientifiche</h3>
          
          <div className="technique">
            <h4>🔄 Interleaving</h4>
            <p>
              Non dedico un'intera lezione a un solo argomento. Alterno continuamente concetti diversi 
              nella stessa sessione: in analisi logica mescolo vari complementi, nella produzione scritta 
              passiamo da struttura del periodo a scelte lessicali a coesione testuale, in letteratura 
              intrecciamo analisi del testo con contesto storico e riflessione critica. Questo costringe 
              lo studente a distinguere attivamente tra categorie e a sviluppare comprensione reale invece 
              di applicazione meccanica di regole.
            </p>
          </div>
          
          <div className="technique">
            <h4>🧠 Richiamo attivo</h4>
            <p>
              Non rivediamo passivamente gli appunti. Chiedo costantemente di recuperare informazioni 
              dalla memoria, di applicarle a contesti nuovi, di spiegare i concetti con parole proprie. 
              Questo sforzo di recupero consolida l'apprendimento in modo permanente.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ValueProposition;
